import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ModalTextComponent } from '../../modals/modal-text/modal-text.component';
import { ModalUploadBackgroundComponent } from '../../modals/modal-upload-background/modal-upload-background.component';
import { FirebaseService } from '../../service/firebase.service';
import { SharedService } from '../../services/shared.service';
import { StylingService } from '../../services/styling.service';
import { TranslationPipe } from '../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-background-configuration',
  templateUrl: './background-configuration.component.html',
  styleUrls: ['./background-configuration.component.scss']
})
export class BackgroundConfigurationComponent implements OnInit {
  @Input('latestUpdate') latestUpdate: any;
  @Input('config') config: any;
  @Output() configChange = new EventEmitter();
  @Input('index') index: number;
  private dialogRef: any;
  constructor(public sharedService: SharedService,
    public dialog: MatDialog,
    public storage: AngularFireStorage,
    private snackBar: MatSnackBar,
    public firebaseService: FirebaseService,
    public stylingService: StylingService,
    public translation: TranslationPipe,
    public _router: Router) { }

  ngOnInit(): void {
    console.log(this.config);
  }

  setActiveBackground(img) {
    this.config.activeBackground = { url: img.url, name: img.name };
    this.saveChange();
    //this.sharedService.submit(this.latestUpdate).then(d => { this.latestUpdate = d })
  }

  removeBackground(imgUrl) {
    this.checkIfCanRemoveBackground(imgUrl).then(res => {
      console.log(this.config.activeBackground, imgUrl)
      if (this.config.activeBackground.url != imgUrl) {
        this.config.listBackground.splice(this.config.listBackground.indexOf(imgUrl), 1)


        if (!res.exist)
          this.storage.storage.refFromURL(imgUrl).delete();

        this.saveChange();
        //    this.sharedService.submit(this.latestUpdate).then(d => { this.latestUpdate = d })
      }
      else {
        this.snackBar.open(this.translation.transform("warningCannotDeleteBackground") as string, 'OK', { duration: 5000 })
      }

    })
  }


  getNameFromUrl(img) {
    //console.log(img, this.sharedService.urlToNameArray);
    let name;
    this.sharedService.urlToNameArray.forEach((item) => {
      if (item.url == img)
        name = item.name
    })

    return name
  }

  checkIfCanRemoveBackground(imgUrl) {
    let exist: boolean = false;
    return new Promise<any>((resolve, reject) => {
      this.firebaseService.getAllDevicesFromUser().then(d => {
        d.forEach((item) => {
          if (item.id != this.sharedService.selectedDevice.id) {
            if (item.data.config.backgroundURL == imgUrl) {

              exist = true;
            }
            if (item.data.config.listBackgrounds.includes(imgUrl)) {
              exist = true;
            }
          }
        })
        resolve({ exist: exist });
      })
    })
  }

  saveChange() {
    this.configChange.emit(this.config)
    console.log(this.config.action.type)
  }

  onUploadImage() {

    console.log(this.config)
    if (this.config.listBackground.length > this.sharedService.limitImg) {
      this.dialogRef = this.dialog.open(ModalTextComponent, {
        width: '30vw',
        height: '30vh',
        data: this.translation.transform('warningLimitBackground') + `(Maximum ${this.sharedService.limitImg})`
      })
    }
    else {
      this.dialogRef = this.dialog.open(ModalUploadBackgroundComponent, {
        width: '300px',
        height: '300px',
        data:
        {
          title: this.translation.transform('importBackground')
        }
      })

      this.dialogRef.afterClosed().subscribe(result => {


        this.firebaseService.uploadFiles(result.target.files, 'baseConfig/backgrounds').then((preData) => {
          //console.log(preData)
          let data = [];
          preData.forEach((d) => {
            //console.log(d)


            console.log(d)
            data.push({ url: d.url, name: d.data.name });
          })
          this.config.listBackground = this.config.listBackground.concat(data)

          this.configChange.emit(this.config)


          this.sharedService.submit(this.latestUpdate).then(d => {
            this.latestUpdate = d;
          });
          //   console.log(data, this.config)
        })


        /*  if (result) {
  
            this.sharedService.uploadEvent = result;
            this.sharedService.uploadFolder = 'baseConfig/backgrounds';
            this.sharedService.submit(this.latestUpdate).then(d => {
  
              this.latestUpdate = d;
              if (this.sharedService.configForm.backgroundURL == undefined || this.sharedService.configForm.backgroundURL.length <= 0) {
                this.sharedService.configForm.backgroundURL = this.sharedService.configForm.listBackgrounds[0]
                this.sharedService.submit(this.latestUpdate).then(d => {
                  this.latestUpdate = d;
                });
              }
  
              this.sharedService.setMetadateFromImage();
            });
          }*/

      });
    }

  }

  deleteConfig() {
    this.configChange.emit(null);
  }

}
